export const apiDashboard = {
  getDataDashBoard: `${process.env.REACT_APP_SERVICE_PATH_OSP}/api/common/dashboard`,
};
